import styled, { css } from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 3.2rem;
    align-items: center;
    border-radius: 6px;
    background-color:${({ theme }) => theme.colors.__white};
    opacity: 1;
    margin-right:1rem;
    border: solid 1px #ececec; 
    > div:nth-child(1){
        display: flex;
        width: 65px;
        height: 100%;
        padding: 0.5rem;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-radius: 6px 0 0 6px ;
        background-color:#f9f9f9;
    }
    > div:nth-child(2){
        display: flex;
        padding: 0 0.5rem 0 0.5rem;
        width: calc(100% - 65px);
    }
    input {
        display: flex;
        outline: none;
        border: 0px;
        width: 100%;    
        height: 100%;
        font-size: 14px;
        font-weight: normal;
        color:${({ theme }) => theme.colors.__gray[750]};
        background-color: transparent;
        text-indent: 0.2rem;  
        padding-right:0.2rem;
    };
    img {
        width: 25px;
        border-radius: 2px;
    };
`;
export const SelectCountry = styled.div`
    position: absolute;
    width: 100%;
    height: 13rem;
    top: 3.5rem;
    z-index: 9;
    overflow: hidden;
    border-radius: 8px;
    padding: 0.3rem 0.3rem 0 0.3rem;
    background-color:${({ theme }) => theme.colors.__white};
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
    > div:nth-child(1) {
        width: 100%;
        height: 2rem;
        .search-country{
            background-color:#f9f9f9;
        }
    };
    > ul{
        display: flex;
        width: 100%;
        height: 135px;
        margin-top: 10px;
        gap: 5px;
        flex-direction: column;
        overflow: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar{
            width: 5px;
            height: 5px;
        }
        &::-webkit-scrollbar-thumb{
            background-color: rgb(0, 0, 0,0.2);
        }
        > li {
            display: flex;
            width: 100%;
            min-height: 2rem;
            align-items: center;
            padding: 0.2rem;
            gap: 0.5rem;
            border-radius: 4px;
            cursor: pointer;
            &:hover{
                background-color:#f9f9f9;
            }
        }
    };
    ${({isOpen})=> !isOpen &&
        css`
            max-height: 0px;
            padding: 0px;
        `
    };
`;
